import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mzk7kejxf7: FaireBrandEntity = {
  token: "b_mzk7kejxf7",
  type: "brand",
  name: "Post House",
  avatarUrl:
    "https://cdn.faire.com/fastly/43cb9715b4b364d8126e739817b60da7dfc78219bf66187e59ac9b3a4d118b10.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/bb497636c5fd965de5fffd934c60bf16c94256fc53f00b18dfa1a3baf5920040.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/43cb9715b4b364d8126e739817b60da7dfc78219bf66187e59ac9b3a4d118b10.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bb497636c5fd965de5fffd934c60bf16c94256fc53f00b18dfa1a3baf5920040.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 49,
  isInsider: true,
  description:
    "Launched in 2018, Post House is the design abode for graphical, modern home furnishings.\n\nWe believe in relaxed sophistication, bold colors, and patterns powerful enough to turn the heads of anyone who walks into the room. Our designs are modern meets eclectic inspiration, blending current and classic styles for livable, lovable furnishings. The end result is dynamic decor cut from a different kind of cloth that add a pop of pattern and color to your home.\n\nWe work with designers all around the world, from different backgrounds and cultures to help us create a textile brand that merges creativity, fashion for the home, and expression.\n\nHeadquartered in the heart of New York City, Post House sells direct-to-consumers online and at specialty home and lifestyle shops around the world.",
  meta: {
    source: "api",
    importedAt: "2026-06-04T00:13:29.272Z",
    importedBy: "entity-db-cli",
  },
};
